module.exports = __webpack_public_path__ + "img/121.e9e8c073.jpg";